export default function R_ForLoop() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_ForLoop Component</h1>
      <p>This is the R_ForLoop tutorial section.</p>
    </div>
  );
}
